module.exports = __webpack_public_path__ + "img/sdi.45d43cda.png";